import { EFileType } from '@/constant';
import { GetWorkerUseTipListResponse } from '@/services';

import { formatDate, getImageIdsFromContentEditor, map } from 'utils';

export const formatWorkerUseTipDetail = (
	input: GetWorkerUseTipListResponse['content'][number]
) => {
	return {
		...input,
		initialImageIds: getImageIdsFromContentEditor(input.content),
		initialContent: input.content,
		registDt: formatDate(input.registDt),
		updateDt: formatDate(input.updateDt),
		fileList: input?.attachmentList?.map((file) => ({
			...file,
			uid: file.fileId,
			fileType: EFileType.SERVER,
			size: file.fileSize,
		})),
	};
};

export const formatWorkerUseTipList = (
	input: GetWorkerUseTipListResponse['content']
) => {
	return map(input, formatWorkerUseTipDetail);
};
